import type { TuneOutcome } from "../engine/autoTune";
import type { TuneRunner } from "./tuning";

/**
 * The browser's tuning runner: a module Web Worker per run, so the 82 replays never block the UI. Rejects (and the
 * caller keeps the current config) if the worker fails or takes longer than a minute.
 */
export const workerRunner: TuneRunner = (input, cfg) =>
  new Promise<TuneOutcome>((resolve, reject) => {
    const worker = new Worker(new URL("./tuneWorker.ts", import.meta.url), { type: "module" });
    const timer = setTimeout(() => { worker.terminate(); reject(new Error("tuning timed out")); }, 60_000);
    worker.onmessage = (e: MessageEvent<{ outcome?: TuneOutcome; error?: string }>) => {
      clearTimeout(timer);
      worker.terminate();
      if (e.data.outcome) resolve(e.data.outcome);
      else reject(new Error(e.data.error ?? "tuning failed"));
    };
    worker.onerror = (e) => { clearTimeout(timer); worker.terminate(); reject(new Error(e.message)); };
    worker.postMessage({ input: { ...input, offsets: input.offsets.entries() }, cfg });
  });
